import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const EXPANDED_WIDTH = 308;
const COLLAPSED_WIDTH = 72;

const menuItems = [
  { key: "students", label: "Students", path: "/channel-partner-portal/students", icon: PeopleAltOutlinedIcon },
  { key: "counsellors", label: "Counsellors", path: "/channel-partner-portal/counsellors", icon: ContactSupportOutlinedIcon },
  { key: "skill-providers", label: "Skill Providers", path: "/channel-partner-portal/skill-providers", icon: GroupsOutlinedIcon },
  { key: "community-partners", label: "Community Partners", path: "/channel-partner-portal/community-partners", icon: HandshakeOutlinedIcon },
  { key: "earnings", label: "Earnings", path: "/channel-partner-portal/earnings", icon: AccountBalanceWalletOutlinedIcon },
];

const ChannelPartnerSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (item) => {
    if (location.pathname === "/channel-partner-portal" && item.key === "students") return true;
    return (
      location.pathname === item.path
      || location.pathname.startsWith(`${item.path}/`)
    );
  };

  return (
    <Box sx={{ width: collapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH, height: "100%", bgcolor: "#2D315F", color: "#fff", flexShrink: 0, display: "flex", flexDirection: "column", transition: "width .3s cubic-bezier(.4,0,.2,1)", overflow: "hidden" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: collapsed ? "center" : "space-between", px: collapsed ? 2 : 2.25, py: 3.5, borderBottom: "1px solid rgba(255,255,255,.12)", minHeight: 88 }}>
        <Box component="img" src={collapsed ? "/assets/images/swrizeLogoMini.png" : "/assets/images/swrizeLogo.png"} alt="Swrize" sx={{ height: 28, maxWidth: collapsed ? 36 : 130, objectFit: "contain", flexShrink: 0 }} />
        {!collapsed && (
          <IconButton aria-label="Collapse channel partner sidebar" onClick={() => setCollapsed(true)} sx={{ width: 36, height: 36, color: "#fff", border: "1px solid rgba(255,255,255,.55)", borderRadius: "7px" }}>
            <KeyboardArrowLeftIcon />
          </IconButton>
        )}
      </Box>

      {collapsed && (
        <IconButton aria-label="Expand channel partner sidebar" onClick={() => setCollapsed(false)} sx={{ width: 36, height: 36, color: "#fff", border: "1px solid rgba(255,255,255,.55)", borderRadius: "7px", mx: "auto", my: 2 }}>
          <KeyboardArrowRightIcon />
        </IconButton>
      )}

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, px: collapsed ? 2 : 1.75, pt: 2, flex: 1 }}>
        {menuItems.map((item) => {
          const Icon = item.icon;
          const selected = isActive(item);
          const button = (
            <Button key={item.key} fullWidth onClick={() => navigate(item.path)} startIcon={<Icon sx={{ fontSize: 22 }} />} sx={{ justifyContent: collapsed ? "center" : "flex-start", height: 45, px: collapsed ? 0 : 1.5, borderRadius: "8px", textTransform: "none", fontSize: 16, fontWeight: 500, color: "#fff", bgcolor: selected ? "#FFA447" : "transparent", minWidth: collapsed ? 40 : "auto", "&:hover": { bgcolor: selected ? "#FFA447" : "rgba(255,255,255,.08)" }, "& .MuiButton-startIcon": { mr: collapsed ? 0 : 1.5 } }}>
              <Box component="span" sx={{ overflow: "hidden", opacity: collapsed ? 0 : 1, width: collapsed ? 0 : "auto", whiteSpace: "nowrap" }}>{item.label}</Box>
            </Button>
          );
          return collapsed ? (
            <Tooltip key={item.key} title={item.label} placement="right" arrow>
              <Box sx={{ display: "flex", justifyContent: "center" }}>{button}</Box>
            </Tooltip>
          ) : button;
        })}
      </Box>
    </Box>
  );
};

export default ChannelPartnerSidebar;
